module.exports = __webpack_public_path__ + "static/img/role-mj-type-c1508018.8f6279a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role-mj-type-c1508018.png
// module id = OSfl
// module chunks = 1